import {BookmakerDomainModel} from "../../../common/bookmaker/models/bookmaker-domain-model";
import {BettingAdBookmakerApiModel} from "./betting-ad.bookmaker.api-model";
import {ActionButtonModel} from "../../../common/bookmaker/models/action-button/action-button";

export class BettingAdBookmakerDomainModel extends BookmakerDomainModel {
  apiModel: BettingAdBookmakerApiModel;

  constructor(model: BettingAdBookmakerApiModel) {
    super(model)

    this.id = model.ID;
  }

  get name(): String {
    return this.apiModel ? this.apiModel.Name : '';
  }

  get nameForURL(): String {
    return this.apiModel ? this.apiModel.NameForURL : '';
  }

  get imageVersion(): String {
    return this.apiModel ? this.apiModel.ImgVer : null;
  }

  get link(): String {
    return this.actionButton?.link || this.apiModel.URL;
  }

  get actionButton(): ActionButtonModel {
    if(!this.apiModel.ActionButton) {
      return null;
    }

    return new ActionButtonModel({link: this.apiModel.ActionButton.URL, label: this.apiModel.ActionButton.Text});
  }

  get color(): String {
    return this.apiModel.Color;
  }
}

